import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  HiOutlineMail,
  HiOutlineLockClosed,
  HiEye,
  HiEyeOff,
  HiOutlineShieldCheck,
  HiOutlineChartBar,
} from "react-icons/hi";
import { AiOutlineLoading } from "react-icons/ai";
import { GoAlertFill } from "react-icons/go";
import { checkIfAuthenticated } from "../utils/utils";
import useLogin from "../hooks/useLogin";
import { LOGIN } from "../config/apiConfig";
import "./login.css";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [remember, setRemember] = useState(true);
  const [capsOn, setCapsOn] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { isLoggedIn, login } = useLogin(LOGIN.POST_LOGIN_ADMIN);

  useEffect(() => {
    if (checkIfAuthenticated()) window.location.replace("/dashboard");
  }, []);

  useEffect(() => {
    if (isLoggedIn) window.location.replace("/dashboard");
  }, [isLoggedIn]);

  const canSubmit = useMemo(
    () => email.trim().length > 3 && password.trim().length >= 6 && !loading,
    [email, password, loading]
  );

  const handleCapsLock = (e) =>
    setCapsOn(!!(e.getModifierState && e.getModifierState("CapsLock")));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    try {
      setLoading(true);
      setError(null);
      await login(email.trim(), password);
      if (remember) localStorage.setItem("relinq_last_email", email.trim());
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Credenciais inválidas. Tente novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-login">
      <div className="app-login__background-accent" aria-hidden="true" />
      <div className="app-login__panel">
        <div className="app-login__panel-grid">
          <section className="panel-info panel-info--streamlined">
            <div className="app-login__brand">
              <div>
                <p className="brand-title">Relinq Sales</p>
                <p className="brand-subtitle">
                  Ferramenta de Velocidade de Receita
                </p>
              </div>
            </div>
            <p className="panel-intro">
              Plataforma única para controlar riscos, monitorar indicadores
              críticos e garantir governança em todas as etapas da venda.
            </p>
            <div className="panel-highlight">
              <HiOutlineChartBar />
              <div>
                <p>+25% mais eficiência operacional</p>
                <small>
                  Processos padronizados e relatórios acionáveis em segundos.
                </small>
              </div>
            </div>
            <p className="panel-footnote">
              Equipes líderes usam o painel Relinq Sales para decisões rápidas,
              auditáveis e seguras.
            </p>
          </section>
          <section className="panel-form">
            <div className="panel-form__header">
              <p className="eyebrow">Área administrativa</p>
              <h2>Entrar no painel</h2>
              <p className="intro">
                Controle acessos, monitore clientes e valide cobranças com
                segurança.
              </p>
            </div>
            <form className="login-form" onSubmit={handleSubmit} noValidate>
              <label>E-mail corporativo</label>
              <div className="input-wrap">
                <HiOutlineMail />
                <input
                  type="email"
                  placeholder="nome@empresa.com"
                  autoComplete="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <label>Senha</label>
              <div className="input-wrap">
                <HiOutlineLockClosed />
                <input
                  type={showPass ? "text" : "password"}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyUp={handleCapsLock}
                  onKeyDown={handleCapsLock}
                  minLength={6}
                  required
                />
              </div>
              {capsOn && <span className="caps">Caps Lock ativo</span>}
              <button
                type="submit"
                className="login-submit"
                disabled={!canSubmit}
              >
                {loading ? <AiOutlineLoading className="spin" /> : "Entrar"}
              </button>
              {error && (
                <div className="login-error">
                  <GoAlertFill />
                  <span>{error}</span>
                </div>
              )}
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}
